import React from 'react';
import { UserIcon, SettingsIcon, BellIcon, HelpCircleIcon, LogOutIcon, ChevronRightIcon } from 'lucide-react';
interface ProfileScreenProps {
  onLogout: () => void;
}
export function ProfileScreen({
  onLogout
}: ProfileScreenProps) {
  return <div className="p-4 flex flex-col gap-6" data-id="element-204">
      {/* User Card */}
      <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 flex flex-col items-center text-center" data-id="element-205">
        <div className="w-24 h-24 rounded-full bg-gray-100 flex items-center justify-center mb-4 border-4" style={{
        borderColor: '#e6f2f9'
      }} data-id="element-206">
          <span className="text-3xl font-bold" style={{
          color: '#134073'
        }} data-id="element-207">
            JP
          </span>
        </div>
        <h2 className="text-2xl font-bold text-gray-900 mb-1" data-id="element-208">Juan Pérez</h2>
        <p className="text-gray-500 font-medium mb-2" data-id="element-209">Recolector</p>
        <div className="bg-gray-100 px-3 py-1 rounded-full text-sm text-gray-600" data-id="element-210">
          jperez@hsjd.go.cr
        </div>
      </div>

      {/* Menu Options */}
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-211">
        <button className="w-full flex items-center justify-between p-4 border-b border-gray-100 active:bg-gray-50" data-id="element-212">
          <div className="flex items-center gap-3" data-id="element-213">
            <div className="p-2 rounded-lg bg-gray-50 text-gray-600" data-id="element-214">
              <UserIcon className="w-5 h-5" data-id="element-215" />
            </div>
            <span className="font-medium text-gray-700" data-id="element-216">Editar Perfil</span>
          </div>
          <ChevronRightIcon className="w-5 h-5 text-gray-400" data-id="element-217" />
        </button>

        <button className="w-full flex items-center justify-between p-4 border-b border-gray-100 active:bg-gray-50" data-id="element-218">
          <div className="flex items-center gap-3" data-id="element-219">
            <div className="p-2 rounded-lg bg-gray-50 text-gray-600" data-id="element-220">
              <BellIcon className="w-5 h-5" data-id="element-221" />
            </div>
            <span className="font-medium text-gray-700" data-id="element-222">Notificaciones</span>
          </div>
          <ChevronRightIcon className="w-5 h-5 text-gray-400" data-id="element-223" />
        </button>

        <button className="w-full flex items-center justify-between p-4 border-b border-gray-100 active:bg-gray-50" data-id="element-224">
          <div className="flex items-center gap-3" data-id="element-225">
            <div className="p-2 rounded-lg bg-gray-50 text-gray-600" data-id="element-226">
              <SettingsIcon className="w-5 h-5" data-id="element-227" />
            </div>
            <span className="font-medium text-gray-700" data-id="element-228">Configuración</span>
          </div>
          <ChevronRightIcon className="w-5 h-5 text-gray-400" data-id="element-229" />
        </button>

        <button className="w-full flex items-center justify-between p-4 active:bg-gray-50" data-id="element-230">
          <div className="flex items-center gap-3" data-id="element-231">
            <div className="p-2 rounded-lg bg-gray-50 text-gray-600" data-id="element-232">
              <HelpCircleIcon className="w-5 h-5" data-id="element-233" />
            </div>
            <span className="font-medium text-gray-700" data-id="element-234">Ayuda y Soporte</span>
          </div>
          <ChevronRightIcon className="w-5 h-5 text-gray-400" data-id="element-235" />
        </button>
      </div>

      {/* Logout */}
      <button onClick={onLogout} className="w-full h-14 rounded-xl border-2 border-red-500 text-red-500 font-bold text-lg flex items-center justify-center gap-2 active:bg-red-50 transition-colors mt-2" data-id="element-236">
        <LogOutIcon className="w-5 h-5" data-id="element-237" />
        Cerrar Sesión
      </button>

      <p className="text-center text-xs text-gray-400 mt-2" data-id="element-238">
        Lavandería Hospitalaria v1.0.0
      </p>
    </div>;
}